// Shared frontend constants. Import these instead of duplicating string literals
// — a mismatch here previously caused the CurrencyContext localStorage bug
// (see iteration_13 test report).

export const AUTH_TOKEN_KEY = "token";
/**
 * Persistent "the browser has seen a logged-in Career OS user before"
 * marker. Written on any successful login/signup. NOT cleared when the
 * session goes stale (401 from /auth/me) — only cleared on explicit logout
 * from the UI.  Read by the Landing page header to decide between the
 *   Log in | Get started   (never-signed-in visitor)
 * and
 *   Log in | Open dashboard   (returning user whose session may or may
 *                              not still be valid)
 * variants.
 */
export const AUTH_RETURNING_KEY = "career-os-returning";
export const ONBOARDING_DONE_KEY = "career-os-onboarding-done";
export const THEME_KEY = "career-os-theme";
export const CURRENCY_KEY = "career-os-currency";
export const CURRENCY_SOURCE_KEY = "career-os-currency-source";

// Custom event names
export const EV_PROFILE_UPDATED = "career-os:profile-updated";
// Fires when the authenticated user's reporting currency changes.
// Any component that renders currency-sensitive data or has cached
// currency-scoped payloads (e.g. salary reports, roadmap steps,
// financial projections) should listen and refetch.
export const EV_CURRENCY_CHANGED = "career-os:currency-changed";
